<template>
  <v-app style="background-color: white">
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  mounted: function() {
    if ('es' === navigator.language.substr(0, 2)) {
      this.$i18n.locale = 'es'
    } else {
      this.$i18n.locale = 'en'
    }
  }
}
</script>

<style lang="scss">
.croppa-container {
  border-radius: 50%;
  border: 4px solid white;
  > canvas {
    border-radius: 50%;
  }

  svg.icon-remove {
    -webkit-filter: drop-shadow(0 0) !important;
    filter: drop-shadow(0 0) !important;
    right: 2% !important;
    top: 2% !important;
    width: 18%;
    height: 18%;
  }
}

@media (min-width: 1904px) {
  .container {
    max-width: 1264px;
  }
}
</style>
